import { apiSlice } from '../../../api/apiSlice';
import {
    CREATE_RECALCULATION_REQUEST,
    GET_RECALCULATION_JOB_LOGS,
    GET_RECALCULATION_REQUEST,
    GET_SCORECARD_WINDOWSTATUS,
} from '../../../constants';

export const recalculationSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardWindowStatus: builder.query({
            query: (arg: any) => {
                const { scorecardVersionId, year, month } = arg;
                return {
                    url: GET_SCORECARD_WINDOWSTATUS,
                    params: { scorecardVersionId, year, month },
                };
            },
        }),
        createRecalculation: builder.mutation({
            query: (arg: any) => ({
                url: CREATE_RECALCULATION_REQUEST,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['recalculation'],
        }),
        getRecalculationRequest: builder.query({
            query: (arg: any) => {
                const { scorecardId, year, month, employeenumber } = arg;
                return {
                    url: GET_RECALCULATION_REQUEST,
                    params: { scorecardId, year, month, employeenumber },
                };
            },
            providesTags: ['recalculation'],
        }),
        getRecalculationJobLogs: builder.query({
            query: (arg:any) => {
                const { calculationRequestId } = arg;
                return {
                    url: GET_RECALCULATION_JOB_LOGS,
                    params : {calculationRequestId}
                };
            },
        }),
    }),
});

export const {
    useGetScorecardWindowStatusQuery,
    useCreateRecalculationMutation,
    useGetRecalculationRequestQuery,
    useGetRecalculationJobLogsQuery,
} = recalculationSlice;
